import { OAUTH_POSTMESSAGE_SOURCE } from 'oauth/constants';
import { OAuthMessageData } from './types';

export function isOAuthMessage<TData>(
  event: MessageEvent,
): event is MessageEvent<OAuthMessageData<TData>> {
  return event?.data?.source === OAUTH_POSTMESSAGE_SOURCE;
}
